import type { ExpandedState } from '@tanstack/react-table';
import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';

/**
 * Collapses expanded rows whenever the row data is replaced, restoring the
 * legacy table's collapse-on-data-change behavior. TanStack v8 only auto-resets
 * expansion through its grouped row model (which these tables don't use) and
 * keys expansion by an index-based row id, so without this a new page/sort/
 * filter result would leave same-index rows spuriously expanded. Comparing the
 * `data` reference during render (like the resize hook's reseed) resets before
 * paint, avoiding a stale expanded frame.
 */
export const useResetExpandedOnDataChange = <TData>(
  data: TData[],
  setExpanded: Dispatch<SetStateAction<ExpandedState>>,
) => {
  const [seededData, setSeededData] = useState(data);

  if (seededData !== data) {
    setSeededData(data);
    setExpanded({});
  }
};

export default useResetExpandedOnDataChange;
